export type JobLocationType = 'hybrid' | 'on-site' | 'remote';

export type JobEmploymentType =
  | 'full-time'
  | 'part-time'
  | 'contract'
  | 'internship'
  | 'remote';

export type JobStatus = 'active' | 'inactive';

export interface JobListing {
  id: string;
  title: string;
  description: string;
  location: string;
  locationType: JobLocationType;
  employmentType: JobEmploymentType;
  salary?: string;
  skills: string;
  status: JobStatus;
  createdAt: string;
  updatedAt: string;
}

export interface JobPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface JobsListResponse {
  success: true;
  data: JobListing[];
  pagination: JobPagination;
}

export interface JobsListParams {
  page?: number;
  limit?: number;
  location?: string;
  locationType?: JobLocationType;
  employmentType?: JobEmploymentType;
}

export const EMPLOYMENT_TYPE_LABELS: Record<JobEmploymentType, string> = {
  'full-time': 'Full-time',
  'part-time': 'Part-time',
  contract: 'Contract',
  internship: 'Internship',
  remote: 'Remote',
};

export const LOCATION_TYPE_LABELS: Record<JobLocationType, string> = {
  hybrid: 'Hybrid',
  'on-site': 'On-site',
  remote: 'Remote',
};
